<template>
     <b-sidebar id="sidebar-ToolBar" right no-header backdrop bg-variant="transparent" backdrop-variant="dark">
        <div id="ToolBar">
            <div>
                <!--<ProfileInfo></ProfileInfo>-->
                <EmpolyGroup></EmpolyGroup>
                <CallInHistoryv2></CallInHistoryv2>
            </div>
        </div>
      </b-sidebar>
</template>

<script>
    import ProfileInfo from './ProfileInfo'
    import EmpolyGroup from './EmpolyGroup'
    import CallInHistoryv2 from './CallInHistoryv2'
    export default {
        data() {
            return {
            }
        },
        components: {
            //ProfileInfo,
            EmpolyGroup,
            CallInHistoryv2
        },
        methods: {
          
        }
    }
</script>

<style>

    #ToolBar {
        position:fixed;
        width: 396px !important;
        right:0;
        background: #23262B !important;
        z-index:999;
    }
</style>